import API from '../../api/api';
import { toast } from 'sonner';
import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  AUTH_LOADING,
  AUTH_ERROR
} from './types';
import { ROUTES } from '../../config/routing';
import { TOKEN_DURATION } from '../reducers/authReducer';

// Action pour la connexion de l'admin
// actions/authActions.js


export const loginAdmin = (credentials, navigate) => async (dispatch) => {
  dispatch({ type: AUTH_LOADING });
  
  try {
    const res = await API.post('/admin/login', credentials);
    const adminData = res.data.admin;
    const token = res.data.token;

    // Calcul de l'heure d'expiration
    const expiresAt = new Date().getTime() + TOKEN_DURATION;

    // Sauvegarde dans localStorage
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(adminData));
    localStorage.setItem('expiresAt', expiresAt); // ⏱️ Nouveau champ

    dispatch({
      type: LOGIN_SUCCESS,
      payload: {
        token,
        user: adminData
      }
    });
    
    toast.success('Connexion réussie !');
    navigate(`/${ROUTES.ADMIN_DASHBOARD}`);
  } catch (error) {
    const errorMsg = error.response?.data?.error || 'Erreur de connexion';
    toast.error(errorMsg);
    dispatch({
      type: LOGIN_FAIL,
      payload: errorMsg
    });
  }
};




// Action pour la connexion d'un client
export const loginCustomer = (credentials) => async (dispatch) => {
  dispatch({ type: AUTH_LOADING });
  
  try {
    const res = await API.post('/customer/login', credentials);
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('user', JSON.stringify(res.data.customer));
    
    dispatch({
      type: LOGIN_SUCCESS,
      payload: {
        token: res.data.token,
        user: res.data.customer,
        isAdmin: false
      }
    });
    
    toast.success('Connexion réussie!');
    return res.data;
  } catch (error) {
    const errorMsg = error.response && error.response.data.error 
      ? error.response.data.error 
      : 'Erreur de connexion';
    
    toast.error(errorMsg);
    
    dispatch({
      type: LOGIN_FAIL,
      payload: errorMsg
    });
    
    ////throw error;
  }
};

// Action pour l'inscription d'un client
export const registerCustomer = (userData) => async (dispatch) => {
  dispatch({ type: AUTH_LOADING });
  
  try {
    const res = await API.post('/customer/create', userData);
    localStorage.setItem('token', res.data.token);
    localStorage.setItem('user', JSON.stringify(res.data.customer));
    
    dispatch({
      type: LOGIN_SUCCESS,
      payload: {
        token: res.data.token,
        user: res.data.customer,
        isAdmin: false
      }
    });
    
    toast.success('Inscription réussie!');
    return res.data;
  } catch (error) {
    const errorMsg = error.response && error.response.data.error 
      ? error.response.data.error 
      : 'Erreur lors de l\'inscription';
    
    toast.error(errorMsg);
    
    dispatch({
      type: AUTH_ERROR,
      payload: errorMsg
    });
    
    ////throw error;
  }
};

// Action pour la déconnexion
export const logout = () => (dispatch) => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  
  dispatch({ type: LOGOUT });
  toast.info('Vous êtes déconnecté');
};
